<template>
	<div class="home-container">
		<!-- 待办事项卡片 -->
		<el-card class="notice-card" shadow="hover" v-if="configPerm">
			<div slot="header" class="notice-header">
				<span class="notice-title"> <i class="el-icon-s-order"></i> 待办事项 </span>
			</div>

			<div class="todo-list">
				<div v-for="item in todoList" :key="item.key" class="todo-item" :class="{ 'is-disabled': item.count === 0 }" @click="handleClick(item)">
					<span class="todo-item-label">{{ item.label }}</span>
					<span class="todo-item-count" :class="{ 'has-count': item.count > 0 }">
						{{ item.count }}
					</span>
				</div>
			</div>
		</el-card>

		<!-- 消息卡片 -->
		<el-card class="notice-card" shadow="hover">
			<div slot="header" class="notice-header">
				<span class="notice-title"> <i class="el-icon-bell"></i> 系统公告 </span>
			</div>

			<div class="notice-body">
				<div class="notice-list" v-if="noticeList.length > 0">
					<div v-for="item in noticeList" :key="item.id" class="notice-item" @click="showDetail(item)">
						<div class="notice-item-header">
							<span class="notice-item-title">
								<el-tag v-if="item.isPinned === 1" type="danger" size="mini" effect="dark" class="pinned-tag">置顶</el-tag>
								{{ item.messageTitle }}
							</span>
							<span class="notice-item-time">{{ formatTime(item.createTime) }}</span>
						</div>
						<div class="notice-item-content">
							{{ item.messageContent }}
						</div>
					</div>
				</div>

				<div v-else class="notice-empty">暂无公告</div>
			</div>

			<!-- 分页器 -->
			<div class="notice-pagination" v-if="total > 0">
				<el-pagination background layout="prev, pager, next" :current-page="queryParams.pageNum" :page-size="queryParams.pageSize" :total="total" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-card>

		<!-- 详情弹窗 -->
		<el-dialog :title="currentNotice.messageTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<div class="notice-detail">
				<div class="notice-detail-time">发布时间：{{ formatTime(currentNotice.createTime) }}</div>
				<div class="notice-detail-content">
					{{ currentNotice.messageContent }}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import http from "@/utils/http";

	export default {
		name: "HomeNotice",
		data() {
			return {
				todoList: [],
				noticeList: [],
				total: 0,
				dialogVisible: false,
				currentNotice: {},
				queryParams: {
					pageNum: 1,
					pageSize: 6,
				},
				// 配置项：显示顺序按需求排列
				todoConfig: [
					{ key: "initOrders", label: "待审核订单", route: "/order/OrderView" },
					{ key: "initInvoices", label: "待审核发票", route: "/order/Invoice" },
					{ key: "initUserHospitals", label: "待审核用户市场申请", route: "/order/Market" },
					{ key: "initReferees", label: "待审核介绍人关系申请", route: "/order/Referee" },
					{ key: "approveWithdraws", label: "待打款提现申请", route: "/order/WithdrawalView" },
					{ key: "initWithdraws", label: "待审核提现申请", route: "/order/WithdrawalView" },
					{ key: "approveOrders", label: "待发货订单", route: "/order/OrderView" },
					{ key: "count", label: "新增用户", route: "/system/UserView" },
				],
				configPerm: false,
			};
		},
		methods: {
			getConfigPerm() {
				let userInfo = sessionStorage.getItem("userInfo");
				console.log(JSON.parse(userInfo).permissions.includes("config:view"));
				if (!userInfo || !JSON.parse(userInfo).permissions) {
					return false;
				}
				return JSON.parse(userInfo).permissions.includes("config:view") || JSON.parse(userInfo).permissions.includes("all:all");
			},
			// 获取待办数据
			getTodoData() {
				http.post("/config/get-data").then((res) => {
					if (res.data.code === 200) {
						const data = res.data.data;
						this.todoList = this.todoConfig.map((item) => ({
							...item,
							count: data[item.key] || 0,
						}));
					}
				});
			},

			// 点击跳转
			handleClick(item) {
				if (item.count === 0) return;
				this.$router.push(item.route);
			},

			// 获取公告分页列表
			getNoticeList() {
				http.post("/notice/page", this.queryParams).then((res) => {
					if (res.data.code === 200) {
						// 后端已按 is_pinned DESC, create_time DESC 排序，前端不再排序
						this.noticeList = res.data.data.records || [];
						this.total = res.data.data.total || 0;
					}
				});
			},

			// 翻页
			handleCurrentChange(val) {
				this.queryParams.pageNum = val;
				this.getNoticeList();
			},

			// 格式化时间
			formatTime(time) {
				if (!time) return "";
				const date = new Date(time);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0");
				const day = String(date.getDate()).padStart(2, "0");
				const hours = String(date.getHours()).padStart(2, "0");
				const minutes = String(date.getMinutes()).padStart(2, "0");
				return `${year}-${month}-${day} ${hours}:${minutes}`;
			},

			// 显示详情弹窗
			showDetail(item) {
				this.currentNotice = item;
				this.dialogVisible = true;
			},
		},
		created() {
			this.getNoticeList();
			let flag = this.getConfigPerm();
      this.configPerm = flag
			if (flag) {
				this.getTodoData();
			}
		},
	};
</script>

<style scoped>
	.home-container {
		padding: 20px;
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.notice-card {
		width: 100%;
		max-width: 500px;
		border-radius: 8px;
	}

	.notice-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.notice-title {
		font-size: 16px;
		font-weight: bold;
		color: #303133;
	}

	.notice-title i {
		margin-right: 8px;
		color: #409eff;
	}

	/* 待办列表样式 */
	.todo-list {
		padding: 0;
	}

	.todo-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #ebeef5;
		cursor: pointer;
		transition: all 0.2s;
	}

	.todo-item:last-child {
		border-bottom: none;
	}

	.todo-item:hover:not(.is-disabled) {
		background-color: #f5f7fa;
		margin: 0 -20px;
		padding: 12px 20px;
	}

	.todo-item.is-disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	.todo-item-label {
		font-size: 14px;
		color: #303133;
	}

	.todo-item-count {
		font-size: 24px;
		font-weight: bold;
		color: #909399;
		min-width: 40px;
		text-align: right;
	}

	.todo-item-count.has-count {
		color: #e6a23c;
	}

	/* 公告区域：列表独立滚动，分页器固定底部 */
	.notice-body {
		/* height: 300px; */
		overflow: hidden;
	}

	.notice-list {
		height: 100%;
		overflow-y: auto;
		padding-right: 5px;
		overflow-x: hidden;
	}

	/* 自定义滚动条 */
	.notice-list::-webkit-scrollbar {
		width: 6px;
	}

	.notice-list::-webkit-scrollbar-thumb {
		background-color: #dcdfe6;
		border-radius: 3px;
	}

	.notice-list::-webkit-scrollbar-thumb:hover {
		background-color: #c0c4cc;
	}

	.notice-item {
		padding: 12px 0;
		border-bottom: 1px solid #ebeef5;
		cursor: pointer;
		transition: background-color 0.2s;
	}

	.notice-item:last-child {
		border-bottom: none;
	}

	.notice-item:hover {
		background-color: #f5f7fa;
		margin: 0 -20px;
		padding: 12px 20px;
	}

	.notice-item-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.notice-item-title {
		font-size: 14px;
		font-weight: 500;
		color: #303133;
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 8px;
	}

	.pinned-tag {
		margin-right: 4px;
		vertical-align: middle;
	}

	.notice-item-time {
		font-size: 12px;
		color: #909399;
		flex-shrink: 0;
	}

	.notice-item-content {
		font-size: 13px;
		color: #606266;
		line-height: 1.5;

		/* 两行省略 */
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.notice-empty {
		text-align: center;
		padding: 40px 0;
		color: #909399;
		font-size: 14px;
	}

	/* 分页器 */
	.notice-pagination {
		margin-top: 12px;
		text-align: center;
		border-top: 1px solid #ebeef5;
		padding-top: 12px;
	}

	/* 详情弹窗样式 */
	.notice-detail {
		padding: 10px 0;
	}

	.notice-detail-time {
		font-size: 13px;
		color: #909399;
		margin-bottom: 20px;
	}

	.notice-detail-content {
		font-size: 14px;
		color: #303133;
		line-height: 1.8;
		white-space: pre-wrap;
		word-break: break-all;
	}
</style>
